import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { Entity } from '@nx-data/nx-data';
import { ClassType } from '@nx-data/utilities';
import { NgxDatabase } from './ngx-database';
import { NgxTable } from './ngx-table';

@NgModule({
  imports: [CommonModule],
})
export class NgxDatabaseModule {
  static forRoot(...entities: ClassType<Entity>[]): ModuleWithProviders<NgxDatabaseModule> {
    return {
      ngModule: NgxDatabaseModule,
      providers: [
        {
          provide: NgxDatabase,
          useFactory: () => {
            const dbInstance = new NgxDatabase();
            entities.unique().forEach((entityClass) => new NgxTable(entityClass.name, entityClass, dbInstance));
            return dbInstance;
          },
        },
      ],
    };
  }
}
